module.exports = __webpack_public_path__ + "static/media/sound-click.68ab68ec.mp3";